import * as RegisterService from '../services/register-service';

export function resetReducer() {
  return function (dispatch) {
    dispatch(reset());
  };
}

export function sendVerificationCode(email) {
  return async function (dispatch) {
    dispatch(process('SENDING_EMAIL'));
    try {
      const response = await RegisterService.sendVerificationEmail(email);
      return dispatch(success('EMAIL_SENT_SUCCESS', response.data));
    } catch (err) {
      return dispatch(error('EMAIL_SENT_ERROR', err));
    }
  };  
}

export function verifyEmailToken(email, token) {
  return async function (dispatch) {
    dispatch(process('PROCESSING_VERIFICATION'));
    try {
      const response = await RegisterService.verifyEmail(email, token);
      return dispatch(success('VERIFICATION_SUCCESS', response.data));
    } catch (err) {
      return dispatch(error('VERIFICATION_ERROR', err));
    }
  };  
}

export function registerUser(user) {
  return async function (dispatch) {
    dispatch(process('PROCESSING_REGISTRATION'));
    try {
      const response = await RegisterService.registerUser(user);
      return dispatch(success('REGISTRATION_SUCCESS', response.data));
    } catch (err) {
      return dispatch(error('REGISTRATION_ERROR', err));
    }
  };
}

function reset() {
  return {
    type: 'RESET_REGISTRATION_STATE'
  };
}

function process(type) {
  return {
    type: type,
  };
}

function success(type, data) {
  return {
    type: type,
    payload: data,
  };
}
function error(type, err) {
  let message;
  if (err.response) {
    // Request made and server responded
    const { data } = err.response;
    message = data && data.message;
  } else if (err.request) {
    // The request was made but no response was received
    message = err.request;
  } else {
    // Something happened in setting up the request that triggered an Error
    message = err.message;
  }
  return {
    type: type,
    payload: message,
  };
}